import React, { useState } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import UploadImg from "../../assets/images/icons/upload-img.svg";
import { useNavigate } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { UI_CONSTANTS } from "../../utils/constants";

function AddCuisine() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    image: null,
  });
  const [imagePreview, setImagePreview] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        image: file,
      }));

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error(UI_CONSTANTS.TOAST_MESSAGES.VALIDATION.ENTER_CUISINE_NAME);
      return;
    }

    const nameRegex = /^[A-Za-z\s]+$/;
    if (!nameRegex.test(formData.name.trim())) {
      toast.error("Cuisine name should only contain letters and spaces");
      return;
    }

    if (!formData.image) {
      toast.error("Please select an image");
      return;
    }

    setLoading(true);
    try {
      const submitData = new FormData();
      submitData.append("name", formData.name);
      submitData.append("image", formData.image);

      const response = await handleApiCall("post", endpoints.addCuisine, submitData);

      if (response?.data?.code === UI_CONSTANTS.API_CODES.CREATED) {
        toast.success(response?.data?.message || UI_CONSTANTS.TOAST_MESSAGES.SUCCESS.CUISINE_ADDED);
        // Add a small delay to ensure toast is shown before navigation
        setTimeout(() => {
          navigate(UI_CONSTANTS.ROUTES.CUISINE_LIST);
        }, UI_CONSTANTS.TIMEOUTS.REDIRECT_DELAY);
      }
      // API errors are already handled by handleApiCall
    } catch (error) {
      console.error("Error adding cuisine:", error);
      // Network errors are already handled by handleApiCall
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      image: null,
    });
    setImagePreview(null);
    navigate(UI_CONSTANTS.ROUTES.CUISINE_LIST);
  };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">{UI_CONSTANTS.PAGE_TITLES.ADD_CUISINE}</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <form onSubmit={handleSubmit}>
                <div className="card-heading d-flex align-items-center mb-3 pb-2">
                  <div className="d-flex align-items-center justify-content-start col-md-12 px-0">
                    <Button type="submit" className="rounded-lg" disabled={loading}>
                      {loading ? UI_CONSTANTS.BUTTON_LABELS.ADDING : UI_CONSTANTS.BUTTON_LABELS.ADD}
                    </Button>
                    <Button type="button" className="rounded-lg ml-4 bg-white" onClick={handleCancel} disabled={loading}>
                      {UI_CONSTANTS.BUTTON_LABELS.CANCEL}
                    </Button>
                  </div>
                </div>
                <div className="col-md-12 tab-content row px-0 mx-0">
                  <label className="imageUpload" role="button">
                    <input type="file" hidden accept="image/*" onChange={handleImageChange} />
                    {imagePreview ? (
                      <img src={imagePreview} alt="Preview" style={{ width: "100px", height: "100px", objectFit: "cover" }} />
                    ) : (
                      <>
                        <img src={UploadImg} className="icon" />
                        <div className="text-white mt-1">Upload photo</div>
                      </>
                    )}
                  </label>
                </div>
                <h5 className="text-white mt-4 mb-3">CUISINE DETAILS</h5>
                <div className="row mx-n2">
                  <div className="form-group col-md-4 px-2">
                    <input type="text" className="form-control default" placeholder="Cuisine Name" name="name" value={formData.name} onChange={handleInputChange} required />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddCuisine;
